import { a6 as attr, T as escape_html, a0 as bind_props, a4 as ensure_array_like, a1 as spread_props, a5 as store_get, a8 as unsubscribe_stores, P as pop, N as push, R as slot, _ as spread_attributes, $ as clsx, S as getContext } from "./index.js";
import { A as Animate } from "./Animate.js";
import { D as DownloadButton, p as page } from "./stores.js";
import { P as PurchaseButton } from "./PurchaseButton.js";
import { I as Icon } from "./Button.js";
import { L as Link } from "./Link.js";
import "clsx";
import { t as tick } from "./index-server.js";
import { c as classMap } from "./Menu.js";
import { p as prefixFilter, e as exclude } from "./prefixFilter.js";
const brightnessModeDemo = "/_app/immutable/assets/brightness-mode-demo.CKHHBi1W.mp4";
const scheduleChangeDemo = "/_app/immutable/assets/schedule-change-demo.BNQcyrKO.mp4";
const globalChangeDemo = "/_app/immutable/assets/global-change-demo.C3nU2iTg.mp4";
function Highlight($$payload, $$props) {
  let video = $$props["video"];
  let title = $$props["title"];
  let description = $$props["description"];
  $$payload.out += `<div class="bg-white gap-4 flex flex-col"><video autoplay class="rounded-3xl" loop muted playsinline${attr("src", video)}></video> <h3 class="text-2xl font-display font-bold mt-4">${escape_html(title)}</h3> <span class="text-xl leading-relaxed opacity-70">${escape_html(description)}</span></div>`;
  bind_props($$props, { video, title, description });
}
function Highlights($$payload) {
  const features = [
    {
      video: brightnessModeDemo,
      title: "Create & Apply Custom Brightness Modes",
      description: "Whether you're working, gaming, or watching a movie, with just a few clicks, you can set the perfect brightness for your display."
    },
    {
      video: scheduleChangeDemo,
      title: "Use Custom Schedules to Automate Brightness Changes",
      description: "Create custom schedules to automatically adjust your display's brightness without lifting a finger."
    },
    {
      video: globalChangeDemo,
      title: "Adjust Displays Individually or in Sync",
      description: "Change the brightness of all your displays at once or adjust them individually to suit your needs."
    }
  ];
  const each_array = ensure_array_like(features);
  $$payload.out += `<div class="section-container"><div class="section grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12"><!--[-->`;
  for (let i = 0, $$length = each_array.length; i < $$length; i++) {
    let feature = each_array[i];
    Highlight($$payload, spread_props([feature]));
  }
  $$payload.out += `<!--]--></div></div>`;
}
function TrustedBy($$payload, $$props) {
  push();
  var $$store_subs;
  $$payload.out += `<div class="section-container"><div class="section text-white bg-teal-950 rounded-3xl flex flex-col md:flex-row gap-12 items-center justify-between py-24"><span class="text-4xl text-center 2xl:text-left font-display font-bold">Join our growing family of <span class="text-teal-500">${escape_html(store_get($$store_subs ??= {}, "$page", page).data.userCount.toLocaleString())}</span> satisfied users!</span> `;
  DownloadButton($$payload, { background: "dark", primary: false, size: 2 });
  $$payload.out += `<!----></div></div>`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
  pop();
}
function SplitScreen($$payload, $$props) {
  $$payload.out += `<div class="w-full grid grid-cols-1 lg:grid-cols-4 gap-24 items-center">`;
  Animate($$payload, {
    class: "col-span-2",
    children: ($$payload2) => {
      $$payload2.out += `<!---->`;
      slot($$payload2, $$props, "left", {});
      $$payload2.out += `<!---->`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----> `;
  Animate($$payload, {
    class: "col-span-2",
    children: ($$payload2) => {
      $$payload2.out += `<!---->`;
      slot($$payload2, $$props, "right", {});
      $$payload2.out += `<!---->`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div>`;
}
const demo = "/_app/immutable/assets/demo.YtskN_MP.mp4";
function Intro($$payload) {
  $$payload.out += `<section class="section-container"><div class="section p-36 rounded-3xl bg-teal-900/5 text-black">`;
  SplitScreen($$payload, {
    $$slots: {
      left: ($$payload2) => {
        $$payload2.out += `<div slot="left"><video autoplay class="w-full h-full rounded-3xl" loop muted playsinline><source${attr("src", demo)} type="video/mp4"></video></div>`;
      },
      right: ($$payload2) => {
        $$payload2.out += `<div slot="right"><div class="space-y-8 flex flex-col items-center max-w-lg mx-auto text-center">`;
        Icon($$payload2, {
          class: "text-6xl text-teal-900",
          icon: "mdi:cursor-default-click"
        });
        $$payload2.out += `<!----> `;
        Animate($$payload2, {
          children: ($$payload3) => {
            $$payload3.out += `<h2 class="text-teal-900 text-4xl md:text-5xl lg:text-6xl font-display leading-tight font-bold">Accessible &amp; Convenient</h2>`;
          },
          $$slots: { default: true }
        });
        $$payload2.out += `<!----> `;
        Animate($$payload2, {
          children: ($$payload3) => {
            $$payload3.out += `<p class="opacity-70 font-display text-xl lg:text-2xl !leading-relaxed">No more fiddling with display settings or dealing with the dreaded
							Windows brightness slider. All your displays will be automatically
							detected and available for adjustment.</p>`;
          },
          $$slots: { default: true }
        });
        $$payload2.out += `<!----></div></div>`;
      }
    }
  });
  $$payload.out += `<!----></div></section>`;
}
function Checkmark($$payload, $$props) {
  push();
  let {
    use = [],
    class: className = "",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  function getElement() {
    return element;
  }
  $$payload.out += `<span${spread_attributes({
    class: clsx(classMap({
      [className]: true,
      "mdc-chip__checkmark": true
    })),
    ...restProps
  })}>`;
  if (children) {
    $$payload.out += "<!--[-->";
    children?.($$payload);
    $$payload.out += `<!---->`;
  } else {
    $$payload.out += "<!--[!-->";
    $$payload.out += `<svg class="mdc-chip__checkmark-svg" viewBox="-2 -3 30 30"><path class="mdc-chip__checkmark-path" fill="none" stroke="black" d="M1.73,12.91 8.1,19.28 22.79,4.59"></path></svg>`;
  }
  $$payload.out += `<!--]--></span>`;
  bind_props($$props, { getElement });
  pop();
}
function Text($$payload, $$props) {
  push();
  var $$store_subs;
  let {
    use = [],
    class: className = "",
    tabindex = getContext("SMUI:chips:chip:focusable") ? 0 : -1,
    children,
    checkbox,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  let element;
  let input = void 0;
  let internalAttrs = {};
  const nonInteractive = getContext("SMUI:chips:nonInteractive");
  const choice = getContext("SMUI:chips:choice");
  const filter = getContext("SMUI:chips:filter");
  const isSelected = getContext("SMUI:chips:chip:isSelected");
  const roleProps = {
    role: store_get($$store_subs ??= {}, "$filter", filter) ? "checkbox" : store_get($$store_subs ??= {}, "$choice", choice) ? "radio" : "button",
    tabindex
  };
  getContext("SMUI:chips:primary-action:mount");
  getContext("SMUI:chips:primary-action:unmount");
  function waitForTabindex(fn) {
    if (internalAttrs["tabindex"] !== getElement().getAttribute("tabindex")) {
      tick().then(fn);
    }
  }
  function focus() {
    waitForTabindex(() => {
    });
  }
  function getInput() {
    return input;
  }
  function getElement() {
    return element;
  }
  if (store_get($$store_subs ??= {}, "$filter", filter)) {
    $$payload.out += "<!--[-->";
    Checkmark($$payload, spread_props([
      { children: checkbox },
      prefixFilter(restProps, "checkmark$")
    ]));
  } else {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]--> <span${spread_attributes({
    role: "gridcell",
    ...prefixFilter(restProps, "container$")
  })}>`;
  if (store_get($$store_subs ??= {}, "$nonInteractive", nonInteractive)) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<span${spread_attributes({
      class: "mdc-chip__text",
      ...prefixFilter(restProps, "text$")
    })}>`;
    children?.($$payload);
    $$payload.out += `<!----></span>`;
  } else {
    $$payload.out += "<!--[!-->";
    $$payload.out += `<span${spread_attributes({
      class: clsx(classMap({
        [className]: true,
        "mdc-chip__primary-action": true
      })),
      ...store_get($$store_subs ??= {}, "$filter", filter) || store_get($$store_subs ??= {}, "$choice", choice) ? {
        "aria-selected": store_get($$store_subs ??= {}, "$isSelected", isSelected) ? "true" : "false"
      } : {},
      ...roleProps,
      ...internalAttrs,
      ...exclude(restProps, ["checkmark$", "container$", "text$"])
    })}><span${spread_attributes({
      class: "mdc-chip__text",
      ...prefixFilter(restProps, "text$")
    })}>`;
    children?.($$payload);
    $$payload.out += `<!----></span></span>`;
  }
  $$payload.out += `<!--]--></span>`;
  if ($$store_subs) unsubscribe_stores($$store_subs);
  bind_props($$props, { focus, getInput, getElement });
  pop();
}
function Features($$payload) {
  const features = [
    {
      icon: "light_mode",
      title: "Adjust Brightness",
      description: "Effortlessly adjust display brightness individually or in sync with other displays."
    },
    {
      icon: "schedule",
      title: "Scheduling",
      description: "Easily modify brightness levels based on the time of day.",
      pro: true
    },
    {
      icon: "sync_saved_locally",
      title: "Universal Compatibility",
      description: "Unlike other brightness tools, Glimmr works with all display types, regardless of connection type."
    },
    {
      icon: "model_training",
      title: "Brightness Profiles",
      description: "Easily switch between different presets with just a few clicks."
    },
    {
      icon: "donut_small",
      title: "Shade Mode",
      description: "Artificially control brightness levels on displays that don't support native adjustments.",
      pro: true
    },
    {
      icon: "rocket_launch",
      title: "Auto Startup",
      description: "Glimmr starts up with Windows by default and automatically applies your predefined brightness adjustments."
    }
  ];
  const each_array = ensure_array_like(features);
  Highlights($$payload);
  $$payload.out += `<!----> `;
  TrustedBy($$payload);
  $$payload.out += `<!----> `;
  Intro($$payload);
  $$payload.out += `<!----> <div class="section-container bg-teal-900/10 mt-24"><div class="section py-24"><div class="grid grid-cols-1 gap-12 items-center z-10 relative"><div class="mx-auto max-w-4xl text-center"><span class="text-base/7 font-semibold text-teal-600 font-display">Features</span> <h2 class="mt-2 font-display text-balance text-5xl font-semibold tracking-tight text-teal-900 sm:text-6xl">Designed for Simplicity</h2></div> <section class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 p-2 md:p-0"><!--[-->`;
  for (let i = 0, $$length = each_array.length; i < $$length; i++) {
    let feature = each_array[i];
    $$payload.out += `<div class="w-full h-full flex items-stretch justify-stretch">`;
    Animate($$payload, {
      class: "flex-grow",
      children: ($$payload2) => {
        $$payload2.out += `<section class="p-4 md:p-12 gap-8 h-full text-left flex flex-col"><div class="flex flex-col items-center justify-center size-16 p-12 bg-white text-teal-500 rounded-3xl"><span class="material-symbols-outlined !text-5xl">${escape_html(feature.icon)}</span></div> <div class="flex flex-col gap-4"><div class="flex items-center justify-between"><h1 class="text-4xl font-display text-teal-900 leading-tight font-bold">${escape_html(feature.title)}</h1> `;
        if (feature.pro) {
          $$payload2.out += "<!--[-->";
          Link($$payload2, {
            to: "/pricing",
            class: "bg-teal-500 !text-white px-3 py-1 rounded-full",
            children: ($$payload3) => {
              Text($$payload3, {
                children: ($$payload4) => {
                  $$payload4.out += `<!---->PRO`;
                },
                $$slots: { default: true }
              });
            },
            $$slots: { default: true }
          });
        } else {
          $$payload2.out += "<!--[!-->";
        }
        $$payload2.out += `<!--]--></div> <p class="text-xl opacity-80 leading-relaxed">${escape_html(feature.description)}</p></div></section>`;
      },
      $$slots: { default: true }
    });
    $$payload.out += `<!----></div>`;
  }
  $$payload.out += `<!--]--></section> <div class="mx-aut flex flex-col items-center gap-8"><div class="flex gap-2 flex-col md:flex-row">`;
  DownloadButton($$payload, { size: 4 });
  $$payload.out += `<!----> `;
  PurchaseButton($$payload, { context: "features", size: 4 });
  $$payload.out += `<!----></div> `;
  Link($$payload, {
    to: "/pricing",
    children: ($$payload2) => {
      $$payload2.out += `<!---->View Pricing`;
    },
    $$slots: { default: true }
  });
  $$payload.out += `<!----></div></div></div></div>`;
}
export {
  Features as F,
  SplitScreen as S
};
